/* Sales tracking: remember which products each tgin add-to-cart feature added (Build a Routine, quick add, hair quiz).
   Saved as hidden cart details (_tgin_added_<feature> = variant ids) that carry over to the order, for the feature revenue report. */
window.tginTrackAdd = function (source, ids, valueCents) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var key = '_tgin_added_' + source;
  // Microsoft Clarity: event + session tags so recordings and heatmaps can be filtered by feature
  try {
    if (typeof window.clarity === 'function') {
      window.clarity('event', 'tgin_' + source + '_added_to_cart');
      window.clarity('set', 'tgin_feature_used', source);
      window.clarity('set', 'tgin_' + source + '_items', String((ids || []).length));
      if (valueCents > 0) window.clarity('set', 'tgin_' + source + '_value', (valueCents / 100).toFixed(2));
      window.clarity('upgrade', 'tgin_' + source + '_added_to_cart');
    }
  } catch (e) {}
  return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var list = String((cart.attributes || {})[key] || '').split(',').filter(Boolean);
      (ids || []).forEach(function (id) { id = String(id); if (id && list.indexOf(id) === -1) list.push(id); });
      var attrs = {}; attrs[key] = list.join(',');
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
    })
    .catch(function () {});
};

document.addEventListener('DOMContentLoaded', function () {
    let videos = document.querySelectorAll('.video-product-card video') || [];

    videos.forEach((video, index) => {
        if (index === 0) {
            video.play();
        }

        document.addEventListener('custom:video-pause-all', function () {
            video.pause();
        })
    })

    let videoToggles = document.querySelectorAll('.video-product-card .play-toggle') || []

    if (videoToggles && videoToggles.length) {
        videoToggles.forEach(btn => {
            const video = btn.closest('.video-product-card').querySelector('video');
            const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

            let observer = new IntersectionObserver(function (entries, observer) {
                console.log('An intersection happened!');
                console.log(entries);
            });

            observer.observe(video);

            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                if (isVideoPlaying(video)) {
                    video.pause();
                    btn.classList.remove('playing');
                    btn.classList.add('not-playing');
                } else {
                    document.dispatchEvent(new CustomEvent('custom:video-pause-all'));
                    video.play();
                    btn.classList.remove('not-playing');
                    btn.classList.add('playing');
                }
            });
        })
    }
});

document.querySelectorAll('a[href*="#rewards-launcher"]').forEach((elm) => {
    elm.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.StampedFn) {
            window.StampedFn.toggleRewardsModal()
        }
    })
});  (function () { if (window.piQuickAddLoaded) return; window.piQuickAddLoaded = true; document.addEventListener('click', function (e) { var btn = e.target.closest('.pi-qa [data-pi-qa-step]'); if (!btn) return; e.preventDefault(); e.stopPropagation(); var input = btn.parentNode.querySelector('input[name="quantity"]'); var qty = parseInt(input.value, 10) || 1; qty = Math.max(1, qty + parseInt(btn.getAttribute('data-pi-qa-step'), 10)); input.value = qty; }); document.addEventListener('submit', function (e) { var form = e.target.closest('.pi-qa__form'); if (!form) return; e.preventDefault(); e.stopImmediatePropagation(); var qtyInput = form.querySelector('input[name="quantity"]'); if (!(parseInt(qtyInput.value, 10) >= 1)) qtyInput.value = 1; var btn = form.querySelector('.pi-qa__submit'); var label = btn.querySelector('span'); var msg = form.querySelector('.pi-qa__msg'); var original = label.textContent; btn.disabled = true; label.textContent = 'Adding...'; msg.textContent = ''; var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) }).then(function (res) { return res.json().then(function (data) { if (!res.ok) throw data; return data; }); }).then(function (tgData) { try { var tgVid = new FormData(form).get('id'); var tgCents = (tgData && (tgData.final_line_price || (tgData.final_price || tgData.price) * (tgData.quantity || 1))) || 0; if (window.tginTrackAdd && tgVid) window.tginTrackAdd('quickadd', [tgVid], tgCents); } catch (tgE) {} label.textContent = 'Added'; document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); setTimeout(function () { var icon = Array.prototype.find.call(document.querySelectorAll('[data-js-cart-icon]'), function (el) { return el.offsetParent !== null; }); if (icon) icon.click(); }, 450); }).catch(function (err) { label.textContent = original; msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; }).finally(function () { setTimeout(function () { label.textContent = original; btn.disabled = false; }, 1500); }); }, true); })();

(function () { if (window.piQaBuild) return; window.piQaBuild = true; var cache = {}; function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); } function dollars(c) { return '$' + Math.ceil(c / 100).toLocaleString('en-US'); } function roundPrices(root) { var els = root.querySelectorAll('.product-item__price'); for (var i = 0; i < els.length; i++) { var w = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT, null); var n; while ((n = w.nextNode())) { if (/\$[\d,]+\.\d{2}/.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/\$([\d,]+)\.(\d{2})/g, function (m, d, c) { var v = parseInt(d.replace(/,/g, ''), 10) + (c === '00' ? 0 : 1); return '$' + v.toLocaleString('en-US'); }); } } } } function build(card, p) { if (!p) return; var meta = card.querySelector('.product-item__meta'); if (!meta) return; if (!p.available) { meta.insertAdjacentHTML('beforeend', '<div class="pi-qa pi-qa--soldout"><button type="button" class="btn btn--primary pi-qa__submit" disabled aria-disabled="true"><span>Sold out</span></button></div>'); return; } var h = '<div class="pi-qa"><form class="pi-qa__form" novalidate>'; var vs = p.variants || []; var pv = null; for (var pi = 0; pi < vs.length; pi++) { if (vs[pi].available) { pv = vs[pi]; break; } } pv = pv || vs[0]; if (vs.length <= 1) { h += '<input type="hidden" name="id" value="' + vs[0].id + '">'; } else { var first = null; for (var i = 0; i < vs.length; i++) { if (vs[i].available) { first = vs[i].id; break; } } h += '<label class="pi-qa__select-wrap"><span class="visually-hidden">Options</span><select class="pi-qa__select" name="id">'; for (var j = 0; j < vs.length; j++) { h += '<option value="' + vs[j].id + '"' + (vs[j].id === first ? ' selected' : '') + (vs[j].available ? '' : ' disabled') + '>' + esc(vs[j].title) + ' - ' + dollars(vs[j].price) + (vs[j].available ? '' : ' (Sold out)') + '</option>'; } h += '</select></label>'; } h += '<div class="pi-qa__row"><div class="pi-qa__qty"><button type="button" class="pi-qa__qty-btn" data-pi-qa-step="-1" aria-label="Decrease quantity">&minus;</button><input class="pi-qa__qty-input" type="number" name="quantity" value="1" min="1" inputmode="numeric" aria-label="Quantity"><button type="button" class="pi-qa__qty-btn" data-pi-qa-step="1" aria-label="Increase quantity">+</button></div><button type="submit" class="btn btn--primary pi-qa__submit"><span>Add to cart</span><span class="pi-qa__price">' + (pv ? ' - ' + dollars(pv.price) : '') + '</span></button></div><p class="pi-qa__msg" role="status" aria-live="polite"></p></form></div>'; meta.insertAdjacentHTML('beforeend', h); } function scan() { roundPrices(document); var cards = document.querySelectorAll('.product-item:not([data-pi-qa])'); for (var i = 0; i < cards.length; i++) { (function (card) { card.setAttribute('data-pi-qa', '1'); if (card.querySelector('.product-item__video-item')) return; var a = card.querySelector('a[href*="/products/"]'); if (!a) return; var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (!m) return; var handle = m[1]; var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; if (!cache[handle]) { cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); } cache[handle].then(function (p) { build(card, p); }); })(cards[i]); } } var t; function later() { clearTimeout(t); t = setTimeout(scan, 100); } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); } new MutationObserver(function (list) { for (var i = 0; i < list.length; i++) { var nodes = list[i].addedNodes; for (var j = 0; j < nodes.length; j++) { var nd = nodes[j]; if (nd.nodeType === 1 && !(nd.closest && nd.closest('.pi-qa')) && (nd.matches('.product-item, .product-item__price') || nd.querySelector('.product-item, .product-item__price'))) { later(); return; } } } }).observe(document.body, { childList: true, subtree: true }); })();

(function () { function f() { var els = document.querySelectorAll('.product-item__price'); for (var i = 0; i < els.length; i++) { var w = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT, null), n; while ((n = w.nextNode())) { if (/from\s/i.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/(on sale\s+)?from\s+/ig, ''); } } } } f(); document.addEventListener('DOMContentLoaded', f); new MutationObserver(function () { clearTimeout(window.piFromT); window.piFromT = setTimeout(f, 100); }).observe(document.body, { childList: true, subtree: true }); })();
/* Video section: on phones, play the mobile video (if one is set) instead of the desktop one.
   Uses document-level listeners so it also works after the theme editor redraws a section. */
(function () {
  if (window.tginMobileVideo) return;
  window.tginMobileVideo = true;
  var mq = window.matchMedia('(max-width: 719px)');

  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var trigger = e.target.closest('.video__text-container-wrapper');
    if (!trigger) return;
    var section = trigger.closest('[data-section-type="video"]');
    var mobileVideo = section && section.querySelector('.video__video-mobile');
    if (!mobileVideo) return;
    e.stopPropagation();
    var desktopVideo = section.querySelector('.video__video');
    if (desktopVideo) desktopVideo.pause();
    var p = mobileVideo.play();
    if (p && p.catch) p.catch(function () {});
  }, true);

  document.addEventListener('playing', function (e) {
    var video = e.target;
    if (!video.classList || !video.classList.contains('video__video-mobile')) return;
    var section = video.closest('[data-section-type="video"]');
    video.setAttribute('controls', '');
    if (!section) return;
    section.querySelectorAll('.video__overlay, .video__text-container-wrapper, .video__image').forEach(function (el) {
      el.classList.remove('visible');
    });
  }, true);

  function onChange() {
    document.querySelectorAll('[data-section-type="video"]').forEach(function (section) {
      var mobileVideo = section.querySelector('.video__video-mobile');
      if (!mobileVideo) return;
      if (mq.matches) {
        var desktopVideo = section.querySelector('.video__video');
        if (desktopVideo) desktopVideo.pause();
      } else {
        mobileVideo.pause();
      }
    });
  }
  if (mq.addEventListener) { mq.addEventListener('change', onChange); } else if (mq.addListener) { mq.addListener(onChange); }
})();

/* Policy pages: show titles in title case (e.g. "Terms of service" -> "Terms of Service") */
(function () {
  function titleCase(text) {
    var small = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to'];
    return text.split(' ').map(function (word, i) {
      var lower = word.toLowerCase();
      if (i > 0 && small.indexOf(lower) !== -1) return lower;
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }
  function run() {
    document.querySelectorAll('.shopify-policy__title h1').forEach(function (h) {
      h.textContent = titleCase(h.textContent.trim());
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();

/* Rewards page (Smile.io): referral button reads "Get your link" (shown in all caps via CSS) */
(function () {
  function run() {
    document.querySelectorAll('.smile-referrals .smile-cta').forEach(function (a) {
      if (/referral link/i.test(a.textContent)) a.textContent = 'Get your link';
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();

/* Phones: sliders show 1.5 items at a time (the theme only allows whole numbers).
   - Homepage product sliders and "Recommended Products": 1.5 cards
   - Product page main photo slider: 1.15 photos (a small peek of the next photo)
   Waits for the theme's sliders to start, then updates them. Desktop is unchanged. */
(function () {
  var MOBILE_MAX = 719; // the theme switches to its desktop layout at 720px
  var TARGETS = [
    { sel: '.featured-collection-slider__content', perView: 1.5 },
    { sel: '.recommended-products__content', perView: 1.5 },
    { sel: '.product__media-container.swiper', perView: 1.15, space: 8, toStart: true }
  ];
  function apply() {
    if (window.innerWidth > MOBILE_MAX) return;
    TARGETS.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (el) {
        var sw = el.swiper;
        if (!sw || sw.destroyed || sw.params.slidesPerView === t.perView) return;
        sw.params.slidesPerView = t.perView;
        if (sw.originalParams) sw.originalParams.slidesPerView = t.perView;
        if (t.space != null) {
          sw.params.spaceBetween = t.space;
          if (sw.originalParams) sw.originalParams.spaceBetween = t.space;
        }
        if (sw.params.loop && sw.loopDestroy && sw.loopCreate) { sw.loopDestroy(); sw.loopCreate(); }
        sw.update();
        if (t.toStart) { if (sw.params.loop && sw.slideToLoop) sw.slideToLoop(0, 0, false); else sw.slideTo(0, 0, false); }
      });
    });
  }
  var tries = 0;
  var timer = setInterval(function () { apply(); if (++tries > 40) clearInterval(timer); }, 500);
  window.addEventListener('resize', function () { setTimeout(apply, 300); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.featured-collection-slider__navigation-list-item')) setTimeout(apply, 300);
  });
  document.addEventListener('shopify:section:load', function () { setTimeout(apply, 500); });
  // Recommended products load after the page, so check again when they arrive
  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; apply(); }, 400);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 30000);
})();

/* Favorites (wishlist): heart buttons on product cards and product pages, a count in the header,
   and the My Favorites page (/pages/favorites). Favorites are saved in this browser only. */
(function () {
  var KEY = 'tgin_favorites';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.25s-7.5-4.6-7.5-10.05A4.2 4.2 0 0 1 8.7 6c1.42 0 2.6.7 3.3 1.8.7-1.1 1.88-1.8 3.3-1.8a4.2 4.2 0 0 1 4.2 4.2c0 5.45-7.5 10.05-7.5 10.05z"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    refresh();
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
  }
  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function makeButton(handle, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tgin-fav' + (extraClass ? ' ' + extraClass : '');
    b.setAttribute('data-tgin-fav', handle);
    b.innerHTML = HEART;
    setState(b);
    return b;
  }
  function setState(b) {
    var on = has(b.getAttribute('data-tgin-fav'));
    b.classList.toggle('is-saved', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? 'Remove from favorites' : 'Save to favorites');
  }

  function addHearts() {
    // Product cards
    document.querySelectorAll('.product-item').forEach(function (card) {
      if (card.querySelector('.tgin-fav') || card.querySelector('.product-item__video-item')) return;
      var media = card.querySelector('.product-item__media');
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!media || !handle) return;
      media.appendChild(makeButton(handle, 'tgin-fav--card'));
    });
    // Product page main photos
    var pageHandle = handleFromUrl(location.pathname);
    if (pageHandle && /^\/products\//.test(location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ''))) {
      var wrap = document.querySelector('.product__primary-left') || document.querySelector('.product__media');
      if (wrap && !wrap.querySelector('.tgin-fav--product')) {
        wrap.classList.add('tgin-fav-host');
        wrap.appendChild(makeButton(pageHandle, 'tgin-fav--product'));
      }
    }
  }

  function refresh() {
    document.querySelectorAll('.tgin-fav').forEach(setState);
    var n = read().length;
    document.querySelectorAll('[data-tgin-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    renderPage();
  }

  // My Favorites page
  var cache = {};
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function renderPage() {
    var root = document.querySelector('[data-tgin-wishlist]');
    if (!root) return;
    var grid = root.querySelector('[data-tgin-wishlist-grid]');
    var empty = root.querySelector('[data-tgin-wishlist-empty]');
    var list = read();
    empty.hidden = list.length !== 0;
    if (!list.length) { grid.innerHTML = ''; return; }
    Promise.all(list.map(getProduct)).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? (p.featured_image.indexOf('?') === -1 ? p.featured_image + '?width=600' : p.featured_image + '&width=600') : '';
        var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        html += '<li class="tgin-wishlist__item">' +
          '<a class="tgin-wishlist__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<a class="tgin-wishlist__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="tgin-wishlist__price">' + compare + money(p.price) + '</div>' +
          '<div class="tgin-wishlist__actions"><a class="btn btn--primary btn--medium" href="' + esc(p.url) + '">View product</a></div>' +
          '<button type="button" class="tgin-wishlist__remove" data-tgin-remove="' + esc(list[i]) + '">Remove</button>' +
          '</li>';
      });
      grid.innerHTML = html;
      empty.hidden = html !== '';
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tgin-fav');
    if (b) { e.preventDefault(); e.stopPropagation(); toggle(b.getAttribute('data-tgin-fav')); return; }
    var r = e.target.closest && e.target.closest('[data-tgin-remove]');
    if (r) { e.preventDefault(); var list = read(); var i = list.indexOf(r.getAttribute('data-tgin-remove')); if (i !== -1) { list.splice(i, 1); write(list); } }
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  function init() { addHearts(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Cards that load later (recommended products, quick add, filters)
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; addHearts(); document.querySelectorAll('.tgin-fav').forEach(setState); }, 400);
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Shop Pay installments message: Shop logo in black instead of purple.
   The message is a sealed Shopify component, so the color is added inside it and re-added if it refreshes. */
(function () {
  var LOGO = '#000';
  var CSS = 'svg[role="img"]:has(title), .fill-purple-primary { color: ' + LOGO + ' !important; fill: ' + LOGO + ' !important; } svg[role="img"]:has(title) path { fill: ' + LOGO + ' !important; }';
  function apply() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (el) {
      var sr = el.shadowRoot;
      if (!sr || sr.querySelector('style[data-tgin-shop-logo]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-tgin-shop-logo', '');
      st.textContent = CSS;
      sr.appendChild(st);
      new MutationObserver(function () {
        if (!sr.querySelector('style[data-tgin-shop-logo]')) sr.appendChild(st);
      }).observe(sr, { childList: true });
    });
  }
  var tries = 0;
  var timer = setInterval(function () { apply(); if (++tries > 30) clearInterval(timer); }, 500);
  document.addEventListener('change', function () { setTimeout(apply, 600); });
})();

/* Rewards page VIP tiers: turn Smile's comparison table into one card per tier listing that tier's perks.
   Reads the table Smile renders, so changes made in Smile still show up. */
(function () {
  function build() {
    document.querySelectorAll('.smile-vip').forEach(function (sec) {
      var table = sec.querySelector('.smile-vip__table');
      var frame = sec.querySelector('.smile-vip__table-frame');
      if (!table || !frame || sec.querySelector('.tgin-vip')) return;
      var rows = [].slice.call(table.querySelectorAll('.smile-vip__row'));
      var wrap = document.createElement('div');
      wrap.className = 'tgin-vip';
      [].slice.call(table.querySelectorAll('.smile-vip__tier')).forEach(function (th, i) {
        var card = document.createElement('div');
        card.className = 'tgin-vip__card';
        var head = document.createElement('div');
        head.className = 'tgin-vip__head ' + th.className;
        head.setAttribute('style', th.getAttribute('style') || '');
        head.innerHTML = th.innerHTML;
        card.appendChild(head);
        var ul = document.createElement('ul');
        ul.className = 'tgin-vip__perks';
        rows.forEach(function (row) {
          var label = row.querySelector('.smile-vip__row-label');
          var cell = row.querySelectorAll('.smile-vip__cell')[i];
          if (!label || !cell || cell.querySelector('.smile-vip__dash')) return;
          var val = cell.querySelector('.smile-vip__cell-value');
          var li = document.createElement('li');
          li.className = 'tgin-vip__perk';
          li.innerHTML = '<svg class="tgin-vip__check" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10.5l4 4 8-9" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
          li.querySelector('span').textContent = label.textContent.trim() + (val ? ': ' + val.textContent.trim() : '');
          ul.appendChild(li);
        });
        card.appendChild(ul);
        wrap.appendChild(card);
      });
      frame.parentNode.insertBefore(wrap, frame);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  document.addEventListener('shopify:section:load', build);
})();

/* Rewards page: alt text for the Smile app's images (Smile has no alt text setting). Approved by the tgin team. */
(function () {
  var RULES = [
    ['.smile-header__logo', 'tgin logo'],
    ['.smile-how-it-works__step-icon[src*="join"]', 'Join icon'],
    ['.smile-how-it-works__step-icon[src*="earn"]', 'Earn icon'],
    ['.smile-how-it-works__step-icon[src*="redeem"]', 'Redeem icon'],
    ['.smile-ways-to-earn__tile-image[src*="804a1269ff1fa25fe4007a5b7c815b69"]', 'Pinterest logo'],
    ['.smile-referrals__image-picture', 'Six smiling women with natural curly hair wearing black outfits']
  ];
  function apply() {
    RULES.forEach(function (r) {
      document.querySelectorAll('.smile-llp ' + r[0]).forEach(function (img) {
        if (!img.getAttribute('alt')) img.setAttribute('alt', r[1]);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();

/* Rewards page: Smile's script renames the browser tab after load; keep the page title in the site's "tgin | Page" style. */
(function () {
  if (location.pathname.indexOf('/apps/loyalty') !== 0) return;
  var TITLE = 'tgin | Miracle Babe Club Rewards';
  function fix() { if (document.title !== TITLE) document.title = TITLE; }
  fix();
  var t = document.querySelector('title');
  if (t) new MutationObserver(fix).observe(t, { childList: true, characterData: true, subtree: true });
  new MutationObserver(function () { var n = document.querySelector('title'); if (n && n !== t) { t = n; fix(); } }).observe(document.head, { childList: true });
})();

/* Shop dropdown: work out one gap size so all columns and the photo are spaced equally across the menu */
(function () {
  function eq() {
    if (window.innerWidth < 960) return;
    document.querySelectorAll('.meganav').forEach(function (m) {
      var list = m.querySelector('.meganav__list-parent');
      var prim = m.querySelector('.meganav__primary');
      var innerEl = m.querySelector('.meganav__inner');
      if (!list || !prim || !innerEl) return;
      var lis = [].slice.call(list.children);
      var singles = lis.filter(function (l) { return !l.classList.contains('has-children'); });
      var groups = lis.filter(function (l) { return l.classList.contains('has-children'); });
      var cols = (singles.length ? [singles] : []).concat(groups.map(function (l) { return [l]; }));
      var sum = cols.reduce(function (a, c) { return a + Math.max.apply(null, c.map(function (l) { return l.scrollWidth; })); }, 0);
      var promo = m.querySelector('.meganav-promo');
      var pw = promo && getComputedStyle(promo).display !== 'none' ? promo.offsetWidth : 0;
      var pad = parseFloat(getComputedStyle(prim).paddingLeft) || 0;
      var gaps = (cols.length - 1) + (pw ? 1 : 0);
      if (!gaps) return;
      var g = Math.max(28, Math.floor((innerEl.clientWidth - pad * 2 - sum - pw) / gaps));
      m.style.setProperty('--tgin-mg', g + 'px');
    });
  }
  function run() { eq(); setTimeout(eq, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', function () { clearTimeout(window.__tginEqT); window.__tginEqT = setTimeout(eq, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(eq);
  document.addEventListener('mouseover', function (e) { if (e.target.closest && e.target.closest('.header__links-primary')) eq(); }, { passive: true });
})();

/* Footer "Accessibility" link opens the Accessibly panel (its floating button is hidden in custom.css) */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-tgin-a11y]');
    if (!a) return;
    e.preventDefault();
    var b = document.getElementById('accessiblyAppDialogButton') || document.querySelector('#accessiblyAppWidgetButton button, #accessiblyAppWidgetButton');
    if (b) b.click();
  });
})();

/* Phones: fade the floating "10% OFF" tab while the footer sign-up and links are on screen, so it does not cover them */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var seen = new Set();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
    document.body.classList.toggle('tgin-footer-in-view', seen.size > 0);
  });
  function start() {
    document.querySelectorAll('.footer .footer__newsletter, .footer .footer__bottom').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Turn the Attentive "10% OFF" tab sideways on the left edge, but leave the full pop-up alone */
(function () {
  setInterval(function () {
    var f = document.getElementById('attentive_creative');
    if (!f) return;
    var small = f.offsetWidth > 0 && f.offsetWidth <= 260 && f.offsetHeight <= 90;
    f.classList.toggle('tgin-side-tab', small);
  }, 400);
})();

/* Recharge subscription info pop-up: headline and sub headers in Title Case */
(function () {
  var SMALL = /^(a|an|and|as|at|but|by|for|in|nor|of|on|or|the|to|up|via|with)$/;
  function titleCase(str) {
    return str.split(' ').map(function (w, i, all) {
      var bare = w.toLowerCase().replace(/[^a-z]/g, '');
      if (i > 0 && i < all.length - 1 && SMALL.test(bare)) return w.toLowerCase();
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }
  function fix() {
    document.querySelectorAll('rc-learn-more-modal h1, rc-learn-more-modal h2, rc-learn-more-modal h3').forEach(function (h) {
      if (h.children.length) return;
      var t = h.textContent.trim();
      var tc = titleCase(t);
      if (t !== tc) h.textContent = tc;
    });
  }
  document.addEventListener('click', function () { setTimeout(fix, 50); setTimeout(fix, 400); }, true);
  window.addEventListener('load', function () { setTimeout(fix, 1500); });
})();

/* Footer: wrap emoji in links so they can be shown in brand pink */
(function () {
  function wrap() {
    var re = /([\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}]️?)/u;
    document.querySelectorAll('.footer a').forEach(function (a) {
      if (a.querySelector('.tgin-emoji')) return;
      Array.prototype.slice.call(a.childNodes).forEach(function (n) {
        if (n.nodeType !== 3 || !re.test(n.nodeValue)) return;
        var span = document.createElement('span');
        span.innerHTML = n.nodeValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/([\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}]️?)/gu, '<span class="tgin-emoji" aria-hidden="true">$1</span>');
        while (span.firstChild) a.insertBefore(span.firstChild, n);
        a.removeChild(n);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wrap); else wrap();
})();

/* Superscript every ® on the page (e.g. tgin®), including content that loads later */
(function () {
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|SUP|TITLE|SVG|CODE|PRE)$/;
  function process(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 3)) return;
    var nodes = [];
    if (root.nodeType === 3) { nodes.push(root); }
    else {
      if (SKIP.test(root.nodeName.toUpperCase()) || root.isContentEditable) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (n.nodeValue.indexOf('®') === -1) return NodeFilter.FILTER_REJECT;
          for (var p = n.parentNode; p && p !== document.body; p = p.parentNode) {
            if (p.nodeType === 1 && (SKIP.test(p.nodeName.toUpperCase()) || p.isContentEditable)) return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      while (w.nextNode()) nodes.push(w.currentNode);
    }
    nodes.forEach(function (n) {
      if (!n.parentNode || n.nodeValue.indexOf('®') === -1) return;
      var p = n.parentNode;
      if (p.nodeType === 1 && SKIP.test(p.nodeName.toUpperCase())) return;
      var parts = n.nodeValue.split('®');
      var frag = document.createDocumentFragment();
      parts.forEach(function (txt, i) {
        if (txt) frag.appendChild(document.createTextNode(txt));
        if (i < parts.length - 1) {
          var s = document.createElement('sup');
          s.className = 'tgin-reg';
          s.textContent = '®';
          frag.appendChild(s);
        }
      });
      p.replaceChild(frag, n);
    });
  }
  function start() {
    process(document.body);
    var queue = [], timer = null;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') queue.push(m.target);
        m.addedNodes && m.addedNodes.forEach(function (n) { queue.push(n); });
      });
      if (!timer) timer = setTimeout(function () { var q = queue; queue = []; timer = null; q.forEach(process); }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Video carousels (Moast UGC widget): 5px rounded cards everywhere; arrows hidden except on product pages */
(function () {
  var onProduct = document.body && document.body.classList.contains('template-product');
  var CSS = (onProduct ? '' : '.carousel__prev,.carousel__next{display:none !important;}') +
    '.card{border-radius:5px !important;}';
  var tries = 0;
  function run() {
    document.querySelectorAll('moast-carousel').forEach(function (el) {
      var sr = el.shadowRoot;
      if (!sr || sr.querySelector('style[data-tgin]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-tgin', '');
      st.textContent = CSS;
      sr.appendChild(st);
    });
    if (++tries < 40) setTimeout(run, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Donation widget (donate page): tgin fonts and 5px button corners */
(function () {
  var CSS = ':host{--brand-color-base:#ed028d !important;--brand-color-original:#ed028d !important;--brand-color-on-white:#ed028d !important;--brand-color-links:#ed028d !important;' +
    '--brand-color-lighter:rgba(237,2,141,.15) !important;--donatable-brand-color-lighter-4:rgba(237,2,141,.04) !important;--donatable-brand-color-lighter-5:rgba(237,2,141,.06) !important;' +
    '--donatable-brand-color-lighter-10:rgba(237,2,141,.1) !important;--brand-color-lighter-hover:rgba(237,2,141,.4) !important;--brand-color-darker-hover:#c4007a !important;' +
    '--brand-color-darker:#8a0052 !important;--brand-color-links-darker:#8a0052 !important;}' +
    '*{font-family:"Swiss_721_BT",Helvetica,Arial,sans-serif !important;}' +
    'button,input,.gl-widget__donation-input-field{border-radius:5px !important;}' +
    '.tgin-donate-btn,.tgin-donate-btn *{font-family:"swiss-721-bt-bold-extended",Helvetica,Arial,sans-serif !important;text-transform:uppercase;letter-spacing:.04em;font-size:15px !important;}';
  var tries = 0;
  function run() {
    document.querySelectorAll('gl-donation-widget-container').forEach(function (el) {
      var sr = el.shadowRoot;
      if (!sr) return;
      if (!sr.querySelector('style[data-tgin]')) {
        /* placed first inside the widget, in its own layer, so it outranks the widget's own important styles */
        var st = document.createElement('style');
        st.setAttribute('data-tgin', '');
        st.textContent = '@layer tgin{' + CSS + '}';
        sr.insertBefore(st, sr.firstChild);
      }
      sr.querySelectorAll('button').forEach(function (b) {
        if (/^\s*donate\s*$/i.test(b.textContent)) b.classList.add('tgin-donate-btn');
      });
      /* "Custom amount:" label shown as "Custom Amount:" */
      sr.querySelectorAll('span, label, p').forEach(function (n) {
        if (n.children.length === 0 && /^\s*Custom amount:?\s*$/.test(n.textContent)) n.textContent = n.textContent.replace('Custom amount', 'Custom Amount');
      });
      if (!el.__tginObs && 'MutationObserver' in window) {
        el.__tginObs = new MutationObserver(function () {
          sr.querySelectorAll('span, label, p').forEach(function (n) {
            if (n.children.length === 0 && /^\s*Custom amount:?\s*$/.test(n.textContent)) n.textContent = n.textContent.replace('Custom amount', 'Custom Amount');
          });
        });
        el.__tginObs.observe(sr, { childList: true, subtree: true, characterData: true });
      }
    });
    if (++tries < 40) setTimeout(run, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Homepage "Shop by Hair Type" and "Featured Collections" on phones: smaller cards so more of the next one shows */
(function () {
  var PER_VIEW = 1.25, tries = 0;
  function run() {
    var done = true;
    document.querySelectorAll('[data-section-type="collection-list-slider"] .swiper').forEach(function (el) {
      var s = el.swiper;
      if (!s) { done = false; return; }
      if (s.originalParams && s.originalParams.slidesPerView !== PER_VIEW) {
        s.originalParams.slidesPerView = PER_VIEW;
        if (window.innerWidth < 720) { s.params.slidesPerView = PER_VIEW; s.update(); }
      }
    });
    if (!done && ++tries < 40) setTimeout(run, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // Sliders lower on the page can start up later (when scrolled to), so apply again on scroll
  var sq = false;
  window.addEventListener('scroll', function () { if (sq) return; sq = true; setTimeout(function () { sq = false; run(); }, 200); }, { passive: true });
  document.addEventListener('shopify:section:load', function () { tries = 0; setTimeout(run, 300); });
})();

/* Moast customer videos: tag the widget with how many videos it has, so 1 or 2 videos sit centered on desktop */
(function () {
  function tag() {
    document.querySelectorAll('moast-carousel:not([data-tgin-count])').forEach(function (el) {
      var d = el.querySelector('script.data');
      if (!d) return;
      try { el.setAttribute('data-tgin-count', String(JSON.parse(d.textContent).media.length)); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tag); else tag();
})();

/* Product pages with only one customer video: move it into the right-hand column, under the Ingredients dropdown */
(function () {
  var tries = 0;
  function move() {
    if (!document.body.classList.contains('template-product')) return;
    var mc = document.querySelector('moast-carousel[data-tgin-count="1"]');
    if (!mc) { if (++tries < 20) setTimeout(move, 300); return; }
    var block = mc.closest('.shopify-app-block');
    if (!block || block.classList.contains('tgin-ugc-moved')) return;
    var accs = document.querySelectorAll('.product__primary-right .product__meta > .accordion');
    var target = null;
    accs.forEach(function (a) { if (/^\s*ingredients/i.test(a.textContent)) target = a; });
    if (!target && accs.length) target = accs[accs.length - 1];
    if (!target) return;
    var oldSection = block.closest('.shopify-section');
    block.classList.add('tgin-ugc-moved');
    target.insertAdjacentElement('afterend', block);
    if (oldSection && !oldSection.querySelector('moast-carousel')) oldSection.classList.add('tgin-ugc-empty');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move); else move();
})();

/* Product pages (desktop and phones): Customer Reviews and FAQs share one section with tabs, styled like the blog tabs */
(function () {
  var tries = 0;
  function setup() {
    if (!document.body.classList.contains('template-product')) return;
    var faq = document.querySelector('.jdgm-product-faqs-widget');
    var rev = document.querySelector('.jdgm-review-widget');
    if (!faq || !rev) return;
    if (!faq.querySelector('.jm-faq-row')) { if (++tries < 40) setTimeout(setup, 300); return; }
    var apps = faq.closest('.apps');
    var revItem = rev.closest('.apps > .animation--item');
    var faqItem = faq.closest('.apps > .animation--item');
    if (!apps || !revItem || !faqItem || apps.querySelector('.tgin-rf-nav')) return;
    var nav = document.createElement('ul');
    nav.className = 'tgin-rf-nav';
    nav.setAttribute('role', 'tablist');
    nav.innerHTML =
      '<li><button type="button" role="tab" class="tgin-rf-nav__tab" data-tab="reviews"><span class="tgin-rf-full">Customer Reviews</span><span class="tgin-rf-short">Reviews</span></button></li>' +
      '<li><button type="button" role="tab" class="tgin-rf-nav__tab" data-tab="faqs">FAQ</button></li>';
    apps.insertBefore(nav, revItem);
    revItem.setAttribute('data-tgin-panel', 'reviews');
    faqItem.setAttribute('data-tgin-panel', 'faqs');
    function show(name) {
      apps.setAttribute('data-tgin-tab', name);
      nav.querySelectorAll('.tgin-rf-nav__tab').forEach(function (b) {
        var on = b.getAttribute('data-tab') === name;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.tgin-rf-nav__tab');
      if (b) show(b.getAttribute('data-tab'));
    });
    apps.classList.add('tgin-rf-tabs');
    show('reviews');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* FAQs: let shoppers open more than one question at a time (Judge.me normally closes the others) */
document.addEventListener('click', function (e) {
  var row = e.target.closest && e.target.closest('.jdgm-product-faqs-widget .jm-faq-row');
  if (!row) return;
  var ans = document.getElementById(row.getAttribute('aria-controls'));
  if (!ans) return;
  e.stopImmediatePropagation();
  e.preventDefault();
  var open = row.getAttribute('aria-expanded') !== 'true';
  // Phones: only one question open at a time
  if (open && window.innerWidth < 750) {
    row.closest('.jdgm-product-faqs-widget').querySelectorAll('.jm-faq-row[aria-expanded="true"]').forEach(function (r) {
      if (r === row) return;
      r.setAttribute('aria-expanded', 'false');
      r.classList.remove('jm-faq-row--active');
      var a = document.getElementById(r.getAttribute('aria-controls'));
      if (a) a.style.display = 'none';
    });
  }
  row.setAttribute('aria-expanded', open ? 'true' : 'false');
  row.classList.toggle('jm-faq-row--active', open);
  ans.style.display = open ? '' : 'none';
}, true);

/* FAQ page: show the question groups as tabs (General, Products, each collection, Ingredients, Subscriptions), styled like the blog tabs */
(function () {
  var TABS = [
    { name: 'General', start: 'rich_text_VbyiUe', hide: ['general'] },
    { name: 'Products', start: 'rich-text-3', hide: ['products', 'general'] },
    { name: 'Moist', start: '08550554-4ca0-486c-a0e8-198fc12d0525', hide: ['moist collection'] },
    { name: 'Miracle RepaiRx', start: '03f2fb27-9876-4323-aa90-b04094aafa62', hide: ['mrx collection'] },
    { name: 'Rose Water', start: '90bbdebb-13d3-45bd-bbcb-aaaac63dd70c', hide: ['rose water collection'] },
    { name: 'Balance', start: 'rich_text_43PW6Q', hide: ['balance collection'] },
    { name: 'Miracle Styling', start: 'rich_text_nJFWhw', hide: ['miracle styling collection'] },
    { name: 'Ingredients', start: '155541a9-784b-443b-9d6b-59b4e8916412', hide: ['ingredients'] },
    { name: 'Subscriptions', start: 'rich_text_yLwcqy', hide: ['subscriptions'] }
  ];
  function setup() {
    if (!/\/pages\/faq\/?$/.test(location.pathname)) return;
    var main = document.querySelector('main');
    if (!main || main.querySelector('.tgin-faq-tabs')) return;
    var sections = Array.prototype.slice.call(main.children).filter(function (s) { return s.classList.contains('shopify-section'); });
    var startIdx = TABS.map(function (t) {
      for (var i = 0; i < sections.length; i++) if (sections[i].id.slice(-t.start.length - 2) === '__' + t.start) return i;
      return -1;
    });
    if (startIdx.some(function (i) { return i < 0; })) return; // layout changed: leave the page as it is
    for (var k = 1; k < startIdx.length; k++) if (startIdx[k] <= startIdx[k - 1]) return;
    TABS.forEach(function (t, k) {
      var end = k + 1 < startIdx.length ? startIdx[k + 1] : sections.length;
      for (var i = startIdx[k]; i < end; i++) {
        var sec = sections[i];
        sec.setAttribute('data-tgin-faq-tab', String(k));
        // hide the group titles that the tab name now replaces, and any title-only block left empty
        if (!sec.querySelector('.collapsible-row-list, details')) {
          var hit = false;
          sec.querySelectorAll('h2').forEach(function (h) {
            if (t.hide.indexOf(h.textContent.trim().toLowerCase()) > -1) { h.classList.add('tgin-faq-tab-title'); hit = true; }
          });
          if (hit) {
            var c = sec.cloneNode(true);
            c.querySelectorAll('.tgin-faq-tab-title, style, script').forEach(function (e) { e.remove(); });
            if (!c.textContent.trim()) sec.classList.add('tgin-faq-tab-head');
          }
        }
      }
    });
    var wrap = document.createElement('div');
    wrap.className = 'tgin-faq-tabs';
    var ul = document.createElement('ul');
    ul.className = 'tgin-tabs-nav';
    ul.setAttribute('role', 'tablist');
    ul.innerHTML = TABS.map(function (t, k) {
      return '<li><button type="button" role="tab" class="tgin-tabs-nav__tab" data-tab="' + k + '">' + t.name + '</button></li>';
    }).join('');
    wrap.appendChild(ul);
    sections[startIdx[0]].insertAdjacentElement('beforebegin', wrap);
    function show(k) {
      main.setAttribute('data-tgin-faq-active', String(k));
      ul.querySelectorAll('.tgin-tabs-nav__tab').forEach(function (b) {
        var on = b.getAttribute('data-tab') === String(k);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    ul.addEventListener('click', function (e) {
      var b = e.target.closest('.tgin-tabs-nav__tab');
      if (b) show(b.getAttribute('data-tab'));
    });
    // Arrow buttons to scroll the tab row when it is wider than the space
    ['prev', 'next'].forEach(function (dir) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'tgin-tabs-arrow tgin-tabs-arrow--' + dir;
      a.setAttribute('aria-label', dir === 'next' ? 'More topics' : 'Previous topics');
      a.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' + (dir === 'prev' ? ' style="transform:rotate(180deg)"' : '') + '><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>';
      a.addEventListener('click', function () { ul.scrollBy({ left: (dir === 'next' ? 1 : -1) * Math.max(160, ul.clientWidth * 0.6), behavior: 'smooth' }); });
      wrap.appendChild(a);
    });
    function arrows() {
      var max = ul.scrollWidth - ul.clientWidth;
      wrap.classList.toggle('can-prev', ul.scrollLeft > 4);
      wrap.classList.toggle('can-next', ul.scrollLeft < max - 4);
    }
    ul.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    main.classList.add('tgin-faq-tabbed');
    show(0);
    arrows();
    setTimeout(arrows, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* Judge.me reviews: imported reviews with no country show "United States", and the Balance
   sampling reviews (imported Oct 2026) show a free product disclosure instead of "collected from another provider". */
(function () {
  var COUNTRY = 'United States';
  var FREE_LABEL = 'Received free product for review';
  var BALANCE = /balance-collection/;
  function fix(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('.jdgm-rev').forEach(function (rev) {
      var badge = rev.querySelector('.jdgm-rev__transparency-badge[data-badge-type="review_collected_from_another_provider"]');
      if (!badge) return;
      var loc = rev.querySelector('.jdgm-rev__location');
      if (loc && !loc.textContent.trim()) loc.textContent = ' ' + COUNTRY + ' ';
      var url = rev.getAttribute('data-product-url') || location.pathname;
      // The Balance sampling reviews are marked incentivized in Judge.me, which adds a second "earned a reward" badge.
      var earned = rev.querySelector('.jdgm-rev__transparency-badge[data-badge-type="review_earned_for_future_purchase"]');
      // Judge.me shows only the "earned" badge on these, so that is the one relabeled.
      if (BALANCE.test(url) && earned) {
        if (earned.textContent.trim() && earned.textContent.trim() !== FREE_LABEL) earned.textContent = FREE_LABEL;
      }
    });
  }
  var queued = false;
  function run() { if (queued) return; queued = true; setTimeout(function () { queued = false; fix(document); }, 30); }
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

/* Homepage hero carousel: make sure the visible video is playing (phones can skip autoplay on copied slides) */
(function () {
  var queued = false;
  function playAll() {
    queued = false;
    document.querySelectorAll('.slideshow-slide__video').forEach(function (v) {
      if (v.offsetParent === null && getComputedStyle(v).display === 'none') return;
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }
  function soon() { if (!queued) { queued = true; setTimeout(playAll, 60); } }
  ['DOMContentLoaded', 'load', 'pageshow'].forEach(function (e) { window.addEventListener(e, soon); });
  ['touchstart', 'scroll', 'click'].forEach(function (e) { window.addEventListener(e, soon, { passive: true }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) soon(); });
  function watch() {
    document.querySelectorAll('.slideshow').forEach(function (s) {
      new MutationObserver(soon).observe(s, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* "You might also like these" pop-up (upsell app): button wording in title case */
(function () {
  var MAP = { 'add items to cart': 'Add Items to Cart', 'skip this offer': 'Skip This Offer', 'you might also like these': 'You Might Also Like These' };
  var queued = false;
  function fix() {
    queued = false;
    document.querySelectorAll('.lb-popup .lb-button, .lb-popup .lb-popup-cont-head-title').forEach(function (b) {
      var t = b.textContent.trim(), want = MAP[t.toLowerCase()];
      if (want && t !== want && b.children.length === 0) b.textContent = want;
    });
  }
  new MutationObserver(function () { if (!queued) { queued = true; setTimeout(fix, 30); } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Cart page: the GovX "Get Verified" box is added by its app as a third column; move it under the order summary */
(function () {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  var queued = false;
  function move() {
    queued = false;
    var form = document.querySelector('.cart__form');
    var col = form && form.querySelector('.cart__footer-wrapper');
    if (!col) return;
    // Inside the summary box itself, which stays pinned while scrolling, so the two never overlap
    var box = col.querySelector('.cart__footer') || col;
    form.querySelectorAll('.govx-id-full-wrapper').forEach(function (g) { if (g.parentElement !== box) { g.classList.add('tgin-govx-moved'); box.appendChild(g); } });
  }
  new MutationObserver(function () { if (!queued) { queued = true; setTimeout(move, 30); } }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') move(); else document.addEventListener('DOMContentLoaded', move);
})();

/* Homepage hero carousel: stay on a video slide until the video has played to the end, then move on.
   Image slides keep the normal timing. The carousel's own timer is switched off and this code moves the slides,
   so a slide change can never get stuck waiting. If a phone blocks the video from playing, it moves on after the normal time. */
(function () {
  function setup(tries) {
    var sec = document.querySelector('[id$="__slideshow_CkJxYV"]');
    if (!sec) return;
    var el = sec.querySelector('.swiper'), sw = el && el.swiper;
    if (!sw) { if ((tries || 0) < 40) setTimeout(function () { setup((tries || 0) + 1); }, 250); return; }
    var delay = (sw.params.autoplay && parseInt(sw.params.autoplay.delay, 10)) || 8000;
    var timer, current;
    if (sw.autoplay && sw.autoplay.running) sw.autoplay.stop();
    function activeVideo() {
      var slide = sw.slides[sw.activeIndex];
      if (!slide) return null;
      return Array.prototype.find.call(slide.querySelectorAll('video'), function (v) { return getComputedStyle(v).display !== 'none'; }) || null;
    }
    function next() {
      clearTimeout(timer);
      sw.animating = false;
      sw.slideNext();
    }
    function onChange() {
      clearTimeout(timer);
      if (current) current.onended = null;
      if (sw.autoplay && sw.autoplay.running) sw.autoplay.stop();
      var v = current = activeVideo();
      if (v) {
        v.loop = false;
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        v.onended = next;
        // Backup: video blocked from playing, or stalled well past its length
        timer = setTimeout(function check() {
          if (v.paused && v.currentTime < 0.5) return next();
          var left = ((v.duration || 0) - v.currentTime) * 1000;
          timer = setTimeout(left > 0 ? check : next, Math.max(left, 0) + 4000);
        }, 3000);
      } else {
        timer = setTimeout(next, delay);
      }
    }
    sw.on('slideChange', function () { setTimeout(onChange, 50); });
    sw.on('autoplayStart', function () { setTimeout(function () { sw.autoplay.stop(); }, 0); });
    onChange();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(0); }); else setup(0);
})();

/* Collection banners with text on the right (desktop): shrink the heading to its longest line so wrapped lines
   (e.g. "Collection") start under the first word, while the heading block stays on the right side */
(function () {
  function fit() {
    document.querySelectorAll('.template-collection .image-hero--text-right .image-hero__text-container-heading').forEach(function (h) {
      h.style.width = '';
      h.classList.remove('tgin-fit-heading');
      if (window.innerWidth < 960) return;
      var r = document.createRange();
      r.selectNodeContents(h);
      var max = 0;
      Array.prototype.forEach.call(r.getClientRects(), function (rect) { if (rect.width > max) max = rect.width; });
      if (max > 0) { h.style.width = Math.ceil(max) + 2 + 'px'; h.classList.add('tgin-fit-heading'); }
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(fit, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();

/* Product pages, phones: size / color dropdown stays in step with the buttons and marks sold-out choices */
(function () {
  function sync() {
    document.querySelectorAll('.product__primary-right .product__color-chips').forEach(function (g) {
      var s = g.querySelector('select.dynamic-variant-input');
      if (!s) return;
      var chips = g.querySelectorAll('.product__chip');
      Array.prototype.forEach.call(s.options, function (o) {
        if (!o.getAttribute('data-tgin-label')) o.setAttribute('data-tgin-label', o.textContent.trim());
        var chip = null;
        chips.forEach(function (b) { if (b.getAttribute('data-option-value') === o.value) chip = b; });
        o.textContent = o.getAttribute('data-tgin-label') + (chip && chip.classList.contains('disabled') ? ' (Sold out)' : '');
      });
      if (!s.getAttribute('data-tgin-bound')) {
        s.setAttribute('data-tgin-bound', '1');
        s.addEventListener('change', function () {
          chips.forEach(function (b) { b.classList.toggle('selected', b.getAttribute('data-option-value') === s.value); });
          setTimeout(sync, 400);
        });
        g.addEventListener('click', function () { setTimeout(sync, 400); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  window.addEventListener('load', sync);
})();


/* Product pages, "You May Also Like" (desktop): give every product name the height of the longest one in the row,
   so Add to Cart buttons line up with only as much space as that row needs (2-line names = small gap, 3-line = a bit more) */
(function () {
  var t;
  function sync() {
    document.querySelectorAll('.recommended-products').forEach(function (sec) {
      var titles = Array.prototype.slice.call(sec.querySelectorAll('.product-item__inner:not(.product-item__video-item) .product-item__product-title'));
      titles.forEach(function (el) { el.style.minHeight = ''; });
      if (!titles.length || window.innerWidth < 750) return;
      var max = 0;
      titles.forEach(function (el) { var h = el.getBoundingClientRect().height; if (h > max) max = h; });
      if (max > 0) titles.forEach(function (el) { el.style.minHeight = Math.ceil(max) + 'px'; });
    });
  }
  function later() { clearTimeout(t); t = setTimeout(sync, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  window.addEventListener('load', later);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  // Recommendations load after the page, so re-check when they arrive
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var n = list[i].target;
      if (n.closest && n.closest('.recommended-products, [id*="__recommendations"]')) { later(); return; }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Phones: footer dropdowns (Customer Care, Learn More, Our Promise) open one at a time */
(function () {
  var busy = false;
  function isOpen(btn) {
    var c = btn.parentElement && btn.parentElement.querySelector('.footer__group-content');
    return !!c && c.getBoundingClientRect().height > 2;
  }
  document.addEventListener('click', function (e) {
    if (busy || window.innerWidth >= 960) return;
    var btn = e.target.closest && e.target.closest('.footer button.footer__header');
    if (!btn || isOpen(btn)) return;
    busy = true;
    document.querySelectorAll('.footer button.footer__header').forEach(function (other) {
      if (other !== btn && isOpen(other)) other.click();
    });
    busy = false;
  }, true);
})();


/* About page: links to other websites (Learn More buttons, tgin Foundation) open in a new tab */
(function () {
  if (!/^\/pages\/about\/?$/.test(window.location.pathname)) return;
  function openExternalInNewTab() {
    document.querySelectorAll('main a[href^="http"]').forEach(function (a) {
      if (a.hostname && a.hostname !== window.location.hostname) {
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openExternalInNewTab);
  else openExternalInNewTab();
})();

/* Blog posts: mark short bold lines ("1. Faux Locs", "Tip 1: ...", "Step 1: Prep Braids") as section headings so they get heading spacing */
(function () {
  var rte = document.querySelector('.article__rte');
  if (!rte) return;
  rte.querySelectorAll('p').forEach(function (p) {
    var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length > 90 || /[.!?]$/.test(text)) return;
    var bold = p.querySelector('strong, b');
    if (!bold) return;
    var boldText = (bold.textContent || '').replace(/\s+/g, ' ').trim();
    if (boldText && text.indexOf(boldText) === 0) p.classList.add('tgin-subhead');
  });
  /* Longer paragraphs that open with a bold "Step 2:", "Tip 3:" or "4." start a new section too */
  rte.querySelectorAll('p:not(.tgin-subhead)').forEach(function (p) {
    var bold = p.querySelector('strong, b');
    if (!bold) return;
    var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
    var boldText = (bold.textContent || '').replace(/\s+/g, ' ').trim();
    if (boldText && text.indexOf(boldText) === 0 && /^(step|tip)\s*\d+|^\d+\./i.test(boldText)) p.classList.add('tgin-section-start');
  });
})();

/* Product pages, phones: move the badge row (Science-Backed, Maintains Moisture, ...) to just under the
   "Pay over time with Shop Pay" line, lined up on the left. On wider screens it goes back under the photos. */
(function () {
  var mq = window.matchMedia('(max-width: 959px)');
  var badges, home, homeNext;
  function place() {
    badges = badges || document.querySelector('.left-side-blocks.for-desktop');
    var pay = document.querySelector('.product-form__shop-pay');
    if (!badges || !pay || !badges.querySelector('.product-icons')) return;
    if (!home) { home = badges.parentNode; homeNext = badges.nextSibling; }
    /* the Shop Pay line sits inside the narrow buy-button column, so place the badges after that whole block */
    var anchor = pay.closest('.product__meta > *') || pay;
    if (mq.matches) {
      if (anchor.nextElementSibling !== badges) anchor.insertAdjacentElement('afterend', badges);
      badges.classList.add('tgin-badges-under-pay');
    } else if (badges.parentNode !== home) {
      home.insertBefore(badges, homeNext);
      badges.classList.remove('tgin-badges-under-pay');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
})();

/* Product photo galleries: the gallery scrolls in a loop, so it shows copies of the first and last slides.
   The theme only sets up the play button on the real video slide, so tapping a copied video did nothing.
   Tapping a copied video now jumps to the real video slide and plays it. */
document.addEventListener('click', function (e) {
  var copy = e.target.closest && e.target.closest('.product__media-container.swiper .swiper-slide-duplicate[data-media-type="video"]');
  if (!copy) return;
  var slider = copy.closest('.swiper');
  var sw = slider && slider.swiper;
  if (!sw) return;
  e.preventDefault();
  e.stopPropagation();
  sw.slideToLoop(parseInt(copy.getAttribute('data-swiper-slide-index'), 10) || 0, 0, false);
  setTimeout(function () {
    var real = sw.slides[sw.activeIndex];
    var play = real && real.querySelector('.plyr__control--overlaid, [data-plyr="play"]');
    if (play) play.click();
  }, 60);
}, true);

/* Product photo galleries, desktop: the theme sets up each video's player only once, and the phone gallery is set up first,
   so the desktop copy of the same video was left without any play controls. Give any gallery video without a player
   the browser's standard controls. */
(function () {
  function addControls() {
    document.querySelectorAll('.product__media-item [data-media-type="video"] > video').forEach(function (v) {
      if (v.closest('.plyr') || v.controls) return;
      v.controls = true;
      v.playsInline = true;
      var media = v.closest('[data-media-type="video"]');
      if (media && media.dataset.loop === 'true') v.loop = true;
    });
  }
  var tries = 0;
  var timer = setInterval(function () { addControls(); if (++tries > 20) clearInterval(timer); }, 500);
})();

/* Product pages: lowercase "Points" in the rewards line ("Earn up to X points when completing this purchase") */
(function () {
  function fix() {
    document.querySelectorAll('.product__meta section.slp_1d97ce p').forEach(function (p) {
      if (/\bPoints\b/.test(p.textContent)) p.textContent = p.textContent.replace(/\bPoints\b/g, 'points');
    });
  }
  fix();
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* GOVX widget footer: single space in "Verification is powered by GOVX ID" (the app adds an extra wide space) */
(function () {
  function fix() {
    document.querySelectorAll('.govx-widget-footer .footer-item').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && / /.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/[\s ]+$/, ' ').replace(/ /g, ' ');
      });
      var a = el.querySelector('a');
      if (a && a.textContent !== a.textContent.trim()) a.textContent = a.textContent.trim();
    });
  }
  fix();
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Slideshows: a video slide stays up for the full length of its video (image slides keep the normal timer),
   and the video starts from the beginning each time its slide comes up */
(function () {
  function setup(section) {
    var el = section.querySelector('.swiper');
    var swiper = el && el.swiper;
    if (!swiper || !swiper.params || !swiper.params.autoplay || !swiper.params.autoplay.enabled) return false;
    if (section.dataset.tginVideoTiming) return true;
    section.dataset.tginVideoTiming = '1';

    function videosIn(slide) { return Array.prototype.slice.call(slide.querySelectorAll('video')); }
    function visibleVideo(slide) { return videosIn(slide).filter(function (v) { return v.offsetParent; })[0] || videosIn(slide)[0]; }

    function applyDurations() {
      var changed = false;
      Array.prototype.forEach.call(el.querySelectorAll('.swiper-slide'), function (slide) {
        var v = visibleVideo(slide);
        if (!v || !isFinite(v.duration) || !v.duration) return;
        var ms = String(Math.max(3000, Math.round(v.duration * 1000) - 300));
        if (slide.getAttribute('data-swiper-autoplay') !== ms) { slide.setAttribute('data-swiper-autoplay', ms); changed = true; }
        var dot = section.querySelectorAll('.slideshow-navigation__dot-loader')[+slide.getAttribute('data-swiper-slide-index') || 0];
        if (dot) dot.style.animationDuration = ms + 'ms';
      });
      return changed;
    }

    function restartActive() {
      var active = swiper.slides[swiper.activeIndex];
      if (!active) return;
      videosIn(active).forEach(function (v) {
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play && v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }

    function refresh() {
      if (applyDurations() && swiper.autoplay.running) {
        swiper.autoplay.stop();
        restartActive();
        swiper.autoplay.start();
        Array.prototype.forEach.call(section.querySelectorAll('.slideshow-navigation__dot-loader'), function (l) {
          l.style.animation = 'none'; void l.offsetWidth; l.style.animation = '';
        });
      }
    }

    Array.prototype.forEach.call(section.querySelectorAll('video'), function (v) {
      v.addEventListener('loadedmetadata', refresh);
    });
    swiper.on('slideChange', restartActive);
    window.addEventListener('resize', refresh);
    refresh();
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    var done = true;
    document.querySelectorAll('[data-section-type="slideshow"]').forEach(function (s) { if (!setup(s)) done = false; });
    if (done || ++tries > 40) clearInterval(timer);
  }, 250);
})();

/* Product pages: show the Shop logo in the "with Shop Pay" installments line in black instead of purple
   (Shopify allows the Shop Pay logo in full color, all black or all white) */
(function () {
  function fix() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (el) {
      var root = el.shadowRoot;
      if (!root) return;
      root.querySelectorAll('.text-purple-primary').forEach(function (logo) {
        if (logo.style.color !== 'rgb(0, 0, 0)') logo.style.color = '#000';
      });
      if (!el.dataset.tginShopBlack) {
        el.dataset.tginShopBlack = '1';
        new MutationObserver(fix).observe(root, { childList: true, subtree: true });
      }
    });
  }
  fix();
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();
